import { render, staticRenderFns } from "./studentALesson.vue?vue&type=template&id=105ef281&scoped=true&"
import script from "./studentALesson.vue?vue&type=script&lang=js&"
export * from "./studentALesson.vue?vue&type=script&lang=js&"
import style0 from "./studentALesson.vue?vue&type=style&index=0&id=105ef281&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105ef281",
  null
  
)

export default component.exports